function closeAllTabs() {
  const tabs = Array.from(document.querySelectorAll(".tab-label"));
  console.log(tabs);
  tabs.forEach((tab) => {
    tab.setAttribute('aria-selected', false);
    const panel = document.getElementById(tab.getAttribute('aria-controls'));
    panel.setAttribute('hidden','');
  });
  const btn = document.querySelector(".tab-close-button");
  btn.setAttribute('hidden','');
}

function loadNutritionFacts(elem) {
  try {
    const obj = JSON.parse(elem.getAttribute('data-json'));
    for (const section in obj) {
      if (typeof obj[section] === "object"){
        for (const item in obj[section]){
          var updateItem = elem.querySelector(`#${item}`);
          if (updateItem != null) {
            console.log(`Processing: ${section} -> ${item}`);
            if(section == "Ingredients"){
              console.log(obj[section]);
              updateItem.innerHTML = obj[section][item];
            }
            else{
              const spanEl = updateItem.getElementsByTagName('span')[0];
              const tdEl = updateItem.getElementsByTagName('td')[0];
              
              if (!spanEl) {
                console.error(`No span found for ${item}`);
                continue;
              }
              if (!tdEl) {
                console.error(`No td found for ${item}`);
                continue;
              }
              
              spanEl.innerHTML = obj[section][item][0];
              tdEl.innerHTML = obj[section][item][1];
            }
          } else {
            console.log(`Element not found: #${item}`);
          }
        }
      }
      else {
        var updateItem = section == "Ingredients" ? elem.querySelector(`.ingredient-container`).querySelector('p') : elem.querySelector(`#${section}`);
        if (updateItem != null) {
          console.log(`Processing Level 2: ${section} -> ${obj[section]}`)
          updateItem.innerHTML=obj[section];
        }
        else {
          console.log(`Some error found with ${updateItem}`);
        }
      }
    }
  } catch (error) {
    console.error('Error in loadNutritionFacts:', error);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const tabs = Array.from(document.querySelectorAll('[role="tab"]'));
  const btn = document.querySelector(".tab-close-button");
  const panels = Array.from(document.querySelectorAll("[id$='-nutrition-facts']"));
  
  for(var i = 0; i < panels.length; i++){
    loadNutritionFacts(panels[i]);
  }

  if (window.innerWidth < 768) {
    tabs.forEach((tab) => {
      const selectedTab = tab.querySelectorAll("[aria-selected='true']");
      selectedTab.forEach((el) => {
        el.setAttribute('aria-selected', false);
        const panel = document.getElementById(el.getAttribute('aria-controls'));
        panel.setAttribute('hidden','');
      });
    });
    btn.setAttribute('hidden','');
  }
});